import React from 'react'
import PropTypes from 'prop-types'

import { Button, Spacer } from '@cleartrip/bento'
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg'
import { ReactComponent as ErrorImg } from 'assets/images/errorScreen.svg';
import { ERROR_TYPE } from 'constants/error'

const Error = props => {
    const { title, subTitle, buttonText, onButtonClick, errorType } = props

    if (errorType === ERROR_TYPE.FAILURE) {
        return (
            <div className="w-100p flex flex-column flex-center flex-middle">
                <ErrorImg />
                <Spacer className="pt-8" />
                <div className="fs-24 fw-600 lh-32">{title}</div>
                <Spacer className="pt-4" />
                <div className="fs-16 fw-500 lh-24 error-screen-color ta-center" style={{ width: 328 }}>
                    {subTitle}
                </div>
                <Spacer className="pt-12" />
                <Button
                    type="secondary"
                    onClick={onButtonClick}
                    className="w-280px fs-14 lh-24 fw-600 flex flex-middle flex-center"
                >
                    {buttonText}
                </Button>
            </div>
        )
    }

    return (
        <div className="flex-column flex-center ta-center" style={{ width: '512px' }}>
            <ErrorIcon />
            <h3 className="fs-6 fw-600 mt-7 c-neutral-700 lh-title">{title}</h3>
            <p className="fs-2 mt-2 c-neutral-700 lh-copy">{subTitle}</p>
            {onButtonClick && (
                <Button type="secondary" className="mt-5" size="sm" onClick={onButtonClick}>
                    {buttonText}
                </Button>
            )}
        </div>
    )
}

Error.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func
}
Error.defaultProps = {
    title: '',
    subTitle: '',
    buttonText: ''
}

export default Error
